import { cn } from '@/lib/utils';
import { Loader } from 'lucide-react';
import { LoadingIndicatorProps, LoadingIndicatorSize } from './types';

const sizeClassNames: Record<LoadingIndicatorSize, string> = {
  xs: 'size-3',
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-6',
  xl: 'size-8'
};

const LoadingIndicator = (props: LoadingIndicatorProps) => {
  const {
    className,
    label,
    size = 'md'
  } = props;

  return (
    <span className="inline-flex items-center" role={label ? 'status' : undefined}>
      <Loader
        className={cn(sizeClassNames[size], 'text-accent animate-spin', className)}
        aria-hidden
      />
      {label && <span className="sr-only">{label}</span>}
    </span>
  );
};

export default LoadingIndicator;